import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import Field from 'src/components/10-atoms/form/Field';
import { getFieldError } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import TextInput from 'src/components/10-atoms/form/inputs/TextInput';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import useData from './useData';
const NoteTabFormDrawer = ({ noteID, noteTab, onSuccess, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const [state, actions] = useData(noteID, noteTab);
    const isEditMode = !!noteTab;
    const isLoading = state.createMutation.loading || state.updateMutation.loading;
    useEffectWithCtx(ctx => {
        if (ctx.state.createMutation.data || ctx.state.updateMutation.data) {
            ctx.onSuccess?.(ctx.state.createMutation.data?.ep_addNoteTab || ctx.state.updateMutation.data.ep_editNoteTab);
        }
    }, { onSuccess, state }, [state.createMutation.data, state.updateMutation.data]);
    return (React.createElement(BottomDrawerLayout, null,
        React.createElement(BottomDrawerLayout.Title, null, isEditMode ? 'Edit Tab' : 'Add Tab'),
        React.createElement(BottomDrawerLayout.ScrollableBody, null,
            React.createElement(Field, { label: "Title", error: getFieldError(state.form.fields.title.errors) },
                React.createElement(TextInput, { autoFocus: !isEditMode, placeholder: "Enter tab title", value: state.form.fields.title.value, onChange: actions.form.fields.title.setValue, maxLength: 200, editable: !isLoading }))),
        React.createElement(BottomDrawerLayout.Actions, { btw: 1, spacing: theme.spacing.standard.md, pv: theme.spacing.standard.sm },
            React.createElement(Button, { loading: isLoading, flex: true, onPress: actions.handleSubmit }, isEditMode ? 'Update' : 'Create'))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    scrollView: {
        flex: 1,
    },
    scrollContent: {
        padding: theme.spacing.page,
        paddingBottom: theme.spacing.standard.xl,
    },
    submitButton: {
        marginTop: theme.spacing.standard.md,
    },
}));
export default NoteTabFormDrawer;
